import React, { FC } from 'react';
import ReactMarkdown from 'react-markdown';

import MarkdownP from './MarkdownP';
import MarkdownStrong from './MarkdownStrong';

interface Props {
  content: string;
}
type MarkdownViewProps = Props;

const MarkdownView: FC<MarkdownViewProps> = ({ content }) => {
  return (
    <ReactMarkdown
      components={{
        p: MarkdownP,
        strong: MarkdownStrong
      }}
    >
      {content}
    </ReactMarkdown>
  );
};

export default MarkdownView;
